import { h } from "preact";

import CSSProperties from "../../../foundation/model/CSSProperties";

function ImageMain({ style }: { style?: CSSProperties;}) {
    return (
        <svg style={style} width="152" height="128" viewBox="0 0 152 128" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="152" height="128" rx="2" fill="var(--background-primary)"/>
            <rect x=".5" y=".5" width="151" height="127" rx="1.5" stroke="var(--border-secondary)" stroke-opacity=".15"/>
            <path fill="var(--background-tertiary)" d="M10 57h64v62H10zM10 9h132v18H10z"/>
            <path fill="var(--border-accent)" fill-opacity=".15" stroke="var(--border-accent)" d="M79.5 14.5h8v8h-8zM93.5 14.5h8v8h-8zM107.5 14.5h8v8h-8z"/>
            <path fill="var(--background-tertiary)" d="M80 103h62v16H80z"/>
            <path fill="var(--border-accent)" fill-opacity=".15" stroke="var(--border-accent)" d="M80.5 103.5h61v15h-61z"/>
            <path fill="var(--background-tertiary)" d="M80.969 57H142v16H80.969z"/>
            <path fill="var(--marker-green)" fill-opacity=".15" stroke="var(--marker-green)" d="M80.5 57.5h61v15h-61zM27.5 80.5h28v15h-28z"/>
            <path fill="var(--background-tertiary)" d="M10 34h29v16H10z"/>
            <path fill="var(--marker-green)" fill-opacity=".15" stroke="var(--marker-green)" d="M10.5 34.5h28v15h-28z"/>
            <path fill="var(--background-tertiary)" d="M45 34h29v16H45z"/>
            <path fill="var(--border-accent)" fill-opacity=".15" stroke="var(--border-accent)" d="M45.5 34.5h28v15h-28z"/>
            <path d="M45 32a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v2H45v-2z" fill="var(--border-accent)"/>
            <path fill="var(--background-tertiary)" d="M80 34h62v16H80z"/>
            <path fill="var(--border-accent)" fill-opacity=".15" stroke="var(--border-accent)" d="M80.5 34.5h61v15h-61z"/>
            <path fill="var(--background-tertiary)" d="M80 80h29v16H80z"/>
            <path fill="var(--border-accent)" fill-opacity=".15" stroke="var(--border-accent)" d="M80.5 80.5h28v15h-28z"/>
            <path d="M80 78a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v2H80v-2z" fill="var(--border-accent)"/>
            <path fill="var(--background-tertiary)" d="M114 80h28v16h-28z"/>
            <path fill="var(--marker-peach)" fill-opacity=".15" stroke="var(--marker-peach)" d="M114.5 80.5h27v15h-27z"/>
        </svg>
    );
}

function ImageRight() {
    return (
        <svg width="55" height="159" viewBox="0 0 55 159" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H52C53.6569 0 55 1.34315 55 3V159H0V0Z" fill="var(--background-secondary)"/>
            <rect x="7" y="13" width="42" height="16" rx="2" fill="var(--control-default)"/>
            <rect x="7" y="33" width="42" height="16" rx="2" fill="var(--control-default)"/>
            <rect x="7.5" y="52.5" width="41" height="15" rx="1.5" fill="var(--border-accent)" fill-opacity="0.15" stroke="var(--border-accent)"/>
            <rect x="7" y="72" width="42" height="16" rx="2" fill="var(--control-default)"/>
            <rect x="7" y="91" width="42" height="16" rx="2" fill="var(--control-default)"/>
            <rect x="7" y="111" width="42" height="16" rx="2" fill="var(--control-default)"/>
            <rect x="7" y="130" width="42" height="16" rx="2" fill="var(--control-default)"/>
        </svg>
    );
}

function ImageLinkToStyleguideOnboarding() {
    return (
        <div style={{ display: "flex", alignItems: "center", backgroundColor: "var(--background-primary)" }}>
            <ImageMain style={{ flex: 1 }}/>
            <ImageRight/>
        </div>
    );
}

export default ImageLinkToStyleguideOnboarding;
